export default '/build/34c40c32.svg'